import { arrayMove } from "../../node_modules/.pnpm/@dnd-kit_sortable@8.0.0_@dnd-kit_core@6.3.1_react-dom@18.3.1_react@18.3.1__react@18.3.1__react@18.3.1/node_modules/@dnd-kit/sortable/dist/sortable.esm.js";
const ORDERING_DROP_ANIMATION = {
  duration: 250,
  easing: "ease"
};
const ORDERING_MOUSE_ACTIVATION_CONSTRAINT = {
  distance: 4
};
const ORDERING_TOUCH_ACTIVATION_CONSTRAINT = {
  delay: 180,
  tolerance: 8
};
function reorderOrderingChoices(choices, activeId, overId) {
  const oldIndex = choices.findIndex((choice) => choice.key === activeId);
  const newIndex = choices.findIndex((choice) => choice.key === overId);
  if (oldIndex < 0 || newIndex < 0 || oldIndex === newIndex) {
    return choices;
  }
  return arrayMove(choices, oldIndex, newIndex);
}
export {
  ORDERING_DROP_ANIMATION,
  ORDERING_MOUSE_ACTIVATION_CONSTRAINT,
  ORDERING_TOUCH_ACTIVATION_CONSTRAINT,
  reorderOrderingChoices
};
//# sourceMappingURL=ordering-dnd.js.map
